import React from 'react';

/*
 * Panel — canonical surface primitive (the .card / .panel treatment:
 * token surface, 1px token border, 8px radius, light shadow).
 *
 * tone="sunken" switches to the second neutral layer (toolbars / sub-panels).
 * `as` lets it render as a <section>, <article>, etc. without losing the styling.
 */
export default function Panel({
  as: Tag = 'div',
  tone = 'surface',
  className = '',
  children,
  ...props
}) {
  const cls = [
    'panel',
    tone === 'sunken' ? 'panel-sunken' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={cls} {...props}>
      {children}
    </Tag>
  );
}
